<template>
  <div>
    <header-bar>
      スプリット
    </header-bar>
    <div
      v-if="renderContent"
      class="page-block">
      <div class="page-block__inner">
        <revenue-share-top-section
          :artist-name="revenueShareData[0].product_disc_tracks.product.artist_name"
          :date="revenueShareData[0].product_disc_tracks.created_at"
          :img-src="revenueShareData[0].product_disc_tracks.product.coverart_filepath"
          :release-type="revenueShareData[0].product_disc_tracks.product.type"
          :title="revenueShareData[0].product_disc_tracks.product.title" />
        <div
          class="border-top">
          <h3>現在のステータス</h3>
          <div
            class="my-release-search-wrap"
            style="padding: 0">
            <revenue-share-detail-table
              :data="revenueShareData"
              :headers="actionableTableHeader"
              page-name="detail"
              @handleClick="handleButtonClick" />
          </div>
        </div>
        <div
          class="title-container">
          <div class="owner-table-title">
            1. {{ revenueShareData[0].product_disc_tracks.titles[0].title }}
          </div>
        </div>
        <revenue-share-detail-table
          :data="revenueShareData"
          :headers="tableHeader"
          page-name="detail" />
        <div class="c-btn-wrap">
          <router-link
            :to="{name: 'revenue-share'}"
            class="c-btn c-btn--back">
            戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left" />
          </router-link>
        </div>
      </div>
    </div>
    <confirm-dialog
      :cancel-button-title="'いいえ'"
      :default-button-title="'はい'"
      :is-shown="showResendEmailDialog"
      name="resendEmailDialog"
      title="招待メールを再送信しますか？"
      @closed="showResendEmailDialog = false"
      @cancel-clicked="showResendEmailDialog =false"
      @default-clicked="resendEmail()">
    </confirm-dialog>
    <confirm-dialog
      :cancel-button-title="false"
      :cross-cancel-button="true"
      :default-button-title="false"
      :is-shown="showEmailSentDialog"
      name="emailSuccessfullySentDialog"
      @closed="showEmailSentDialog = false">
      <template
        #body
        class="mb-spacing">
        再送信しました。
        <div class="mb-spacing"></div>
      </template>
    </confirm-dialog>
  </div>
</template>

<script>
import ConfirmDialog from '../../../components/ConfirmDialog'
import HeaderBar from '../HeaderBar'
import RevenueShareTopSection from './RevenueShareTopSection'
import RevenueShareDetailTable from './RevenueShareDetailTable'

export default {
  name: 'Detail',
  components: {
    RevenueShareDetailTable,
    HeaderBar,
    ConfirmDialog,
    RevenueShareTopSection,
  },
  data() {
    return {
      revenueShareData: [{
        id: '',
        email: '',
        rate: '',
        role: '',
        product_disc_tracks: {
          product: {
            titles: [],
          },
          titles: [{
            title: '',
          }],
        },
      }],
      id: '',
      loading: false,
      renderContent: false,
      showResendEmailDialog: false,
      showEmailSentDialog: false,
      emailResendItem: {
        id: null,
        pdId: null,
      },
      tableHeader: [{
        name: '分配率',
        class: 'detail-table',
        isIcon: false,
        key: 'rate',
      },
      {
        name: 'メンバー',
        class: 'detail-table',
        isIcon: false,
        key: 'email',
      },
      {
        name: 'メモ',
        class: 'detail-table',
        isIcon: false,
        key: 'memo',
      },
      {
        name: '役割',
        class: 'detail-table',
        isIcon: false,
        key: 'role.role',
      }],
      actionableTableHeader: [{
        name: 'メンバー',
        class: 'detail-table',
        style: 'width: 26%',
        isIcon: false,
        key: 'email',
      },
      {
        name: 'ステータス',
        class: 'detail-table',
        style: 'width: 15%',
        isIcon: false,
        key: 'status',
        actionable: true,
      },
      {
        name: '送信日時',
        class: 'detail-table',
        style: 'width: 12%',
        isIcon: false,
        key: 'updated_at',
        pipe: 'formatDate',
      },
      {
        name: '有効期限',
        class: 'detail-table',
        style: 'width: 12%',
        isIcon: false,
        key: 'updated_at',
        pipe: 'addDaysToDate',
      },
      {
        name: '再通知',
        class: 'detail-table',
        style: '',
        isIcon: false,
        key: '',
        button: true,
        buttonText: ['招待メールを再送'],
        buttonClass: 'c-btn',
      }],
      revenueShareApi: '/api/client/revenueShare',
    }
  },
  async mounted() {
    this.id = this.$route.params?.id
    await this.getRevenueShareById(this.id)
  },
  methods: {
    async getRevenueShareById(id) {
      const { data } = await window.axios
        .get(this.revenueShareApi, { params: { product_id: id } })
      if (data.data.length === 0) {
        await this.$router.push({ name: 'revenue-share' })
        return
      }
      this.renderContent = true
      this.revenueShareData = data.data
      if (this.revenueShareData?.length && this.revenueShareData.every(val => val.status === 3)) {
        this.actionableTableHeader = [{
          name: 'メンバー',
          class: 'detail-table',
          style: 'width: 14%',
          isIcon: false,
          key: 'email',
        },
        {
          name: 'ステータス',
          class: 'detail-table',
          style: 'width: 15%',
          isIcon: false,
          key: 'status',
          actionable: true,
        },
        {
          name: '送信日時',
          class: 'detail-table',
          style: 'width: 12%',
          isIcon: false,
          key: 'updated_at',
          pipe: 'formatDate',
        },
        {
          name: '有効期限',
          class: 'detail-table',
          style: 'width: 12%',
          isIcon: false,
          key: 'updated_at',
          pipe: 'addDaysToDate',
        }]
      }
    },
    async resendEmail() {
      this.loading = true
      this.showResendEmailDialog = false
      const response = await window.axios.post(`${this.revenueShareApi}/invitationCode/resend`,
        {
          id: this.emailResendItem.id,
          product_disc_track_id: this.emailResendItem.pdId,
        })
      if (response.status === 200) {
        this.loading = false
        this.showEmailSentDialog = true
        this.emailResendItem.id = null
        this.emailResendItem.pdId = null
      }
    },
    showConfirmResendEmail(id, pdId) {
      this.emailResendItem.id = id
      this.emailResendItem.pdId = pdId
      this.showResendEmailDialog = true
    },
    handleButtonClick(event) {
      this.showConfirmResendEmail(event.id, event.product_disc_track_id)
    },
  },
}
</script>

<style scoped>
.my-release-search-wrap {
  height: inherit !important;
  display: block !important;
  border-top: 2px solid #e8e8e8;
  border-right: 2px solid #e8e8e8;
  border-left: 2px solid #e8e8e8;
}

button {
  min-width: 150px;
}

.top-info {
  margin: 24px 0;
}

.my-release-list__table {
  background: white;
  margin-bottom: 2%;
}

.page-block__inner .top-info {
  display: flex;
  align-items: flex-start;
}

.info-title {
  font-size: 26px;
  font-weight: 400;
}

.info-sec {
  font-size: 16px;
  color: #636363 !important;
}

.mb-spacing {
  margin-bottom: 48px;
}
</style>
